import { Component, Input } from '@angular/core';
import { AuthService } from '@core/services/auth/auth.service';
import { CopyContentComponent } from "../../../../../shared/components/copy-content/copy-content.component";
import { TooltipModule } from 'primeng/tooltip';

@Component({
  selector: 'app-email-info',
  standalone: true,
  imports: [CopyContentComponent, TooltipModule],
  templateUrl: './email-info.component.html',
  styleUrl: './email-info.component.scss'
})
export class EmailInfoComponent {

  @Input() headerData: any;
  showReadHistory: boolean = false;

  constructor(
    private _auth : AuthService
  ) {}

  objectKeys(data: any) {
    const users = Object.keys(data);
    const index = users.indexOf(this._auth.userDetail().email);

    if(index !== -1) {
      users.splice(index, 1);
    }

    return users;
  }

  isCurrentUserRead(data: any) {
    return Object.keys(data).includes(this._auth.userDetail().email);
  }

  otherReadUsersCount(data: any) {
    const currentUserRead = this.isCurrentUserRead(data);

    if(currentUserRead) {
      return Object.keys(data).length - 1;
    } else {
      return Object.keys(data).length;
    }
  }

}
